var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty"},[_c('h2',[_vm._v("404")]),_c('p',[_vm._v("Not Found")])])
}]

export { render, staticRenderFns }